import {JsonProperty} from "@hyperloris/tyson";
import {OrdersTradesTableRequest} from "./orders-trades-table-request";

export class ClearingInfoLoadRequest extends OrdersTradesTableRequest {

  @JsonProperty()
  itemIds: string[] = [];
  @JsonProperty()
  ignoreFields: string[] = [];

  selectionBase: boolean = true;

  constructor(itemIds: string[]) {
    super({});
    this.itemIds = itemIds;
  }

  static fromOrdersTradesTableRequest(request: OrdersTradesTableRequest): ClearingInfoLoadRequest {
    return {
      ignoreFields: [],
      itemIds: [],
      rows: request.rows,
      first: request.first,
      filters: request.filters,
      filters2: request.filters2,
      filters3: request.filters3,
      sortOrder: request.sortOrder,
      sortField: request.sortField,
      stateFilter: request.stateFilter,
      selectionBase: false
    };
  }
}
